import { createSlice } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { BlogStateType } from "types/blog";

import { extraReducers } from "./blog.extraReducers";

const initialState: BlogStateType = {
  dataBlogCategory: [],
  dataBlogContentList: {
    data: [],
    totalCount: 0,
    totalPages: 0,
  },
  dataContentBlogDetail: {
    content: "",
  },
  isLoading: false,
};

const blog = createSlice({
  name: "blog",
  initialState,
  reducers: {},
  extraReducers,
});

export const selectBlogCategory = (state: ApplicationRootState) =>
  state.blog.dataBlogCategory;

export const selectBlogContent = (state: ApplicationRootState) =>
  state.blog.dataBlogContentList;

export const selectBlogContentDetail = (state: ApplicationRootState) =>
  state.blog.dataContentBlogDetail;

export const selectIsLoading = (state: ApplicationRootState) =>
  state.blog.isLoading;

export default blog.reducer;
